<template>
  <div class="dem-imp-xml-logs">
    <div class="cabecalho">
      Arquivo: <b v-html="cpntFileName"></b>
    </div>

    <div class="box-geral">
      <table>
        <tr v-for="(log, indexL) in cpntLogs.data" :key="'log--' + indexL">
          <td class="icone">
            <img v-if="[ '200' ].indexOf(log.code) !== -1" src="/img/geral/img_ok.png"/>
            <img v-else-if="[ '406' ].indexOf(log.code) !== -1" src="/img/geral/img_alert.png"/>
            <img v-else src="/img/geral/img_erro.png"/>
          </td>

          <td class="link">
            <template v-if="[ '', null, undefined ].indexOf(log.data) === -1 && [ '', null, undefined ].indexOf(log.data.tipo) === -1">
              <App-Button @onClick="() => { demImpXmlLogsAbrirCadastro(log) }" :cpntClass="[ 'btn', 'btn-default', 'btn-sm' ]">
                <svg class="fas fa-external-link-alt"></svg>
              </App-Button>
            </template>
            <template v-else>
              &nbsp;
            </template>
          </td>

          <td class="message">
            <span v-html="log.message"></span>
          </td>

        </tr>
      </table>
    </div>
  </div>
</template>

<style scoped>

.dem-imp-xml-logs {
  width: 700px;
  max-width: 90%;
  margin: 0px auto;
  padding-top: 30px;
}
  .dem-imp-xml-logs > .cabecalho {
    width: 80%;
    margin: 0px auto;
    text-align: center;
    
    background: #f9f9f9;
    border: 1px solid #e9e9e9;
    padding: 10px 5px 5px 5px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: none;
  }
  .dem-imp-xml-logs > .box-geral {
    width: 100%;
    margin: 0px auto;
    background: #f9f9f9;
    border: 1px solid #e9e9e9;
    padding: 10px;
    border-radius: 10px;
  }

    .dem-imp-xml-logs > .box-geral > table {
      width: 100%;
    }
      .dem-imp-xml-logs > .box-geral > table > tr > td {
        padding: 5px
      }
      .dem-imp-xml-logs > .box-geral > table > tr:not(:first-child) > td {
        border-top: 1px solid #e9e9e9;
      }
      .dem-imp-xml-logs > .box-geral > table > tr > td:first-child {
        width: 50px;
        text-align: center;
      }
</style>

<script>
export default {
  props: {
    cpntLogs: {
      required: true,
      type: Object
    },
    cpntFileName: {
      required: true
    }
  },
  data: function () {
    return {}
  },
  methods: {
    demImpXmlLogsAbrirCadastro: function (log) {
      // INICIA A VARIAVEL PARA PARAMETRO
      var params = {}

      // FAZ A VERIFICAÇÃO DO QUE DEVE ABRIR
      switch (log.data.tipo) {
        case 'contato':
          params = { tipo: 'contato', id: log.data.id_con, editar: false }
          break
        
        case 'produto':
          params = { tipo: 'produto', id: log.data.id_pro }
          break

        case 'dem_compra':
          this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'demanda_tipo_numero', params: { tipo: 'compra', id: log.data.dem_compra } }).href, '_blank')
          break
      }

      // MANDA ABRIR O CADASTRO SOLICITADO
      if (Object.keys(params).length >= 1) {
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params) 
      }
    }
  }
}
</script>